// extracted by mini-css-extract-plugin
export var arboretumheadline = "ArboretumHeadline-module--arboretumheadline--f7edc";
export var text = "ArboretumHeadline-module--text--a3478";